import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Icon } from "@iconify/react";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";
import Phone from "@mui/icons-material/Phone";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import "./ContactInformation.css";
import formatPhoneNumber from "../Helper/formatPhoneNumber";
import { setMakeCall } from "../Store/Actions/CallAction";
// import CallPermissionModal from "../Chat/CallPermissionModal";

const ContactInformation = ({
  campaignID,
  contactID,
  data,
  isAddEditButtonShown,
  setIsAddChangeContactDialogShown,
  setIsAddEditContactDialogShown,
  setIsContactDetailsModalShown,
  acwMode,
  acwDuration,
  isTelemarketing,
  setSelectedNumber,
  setSelectedPhoneTypeID,
  setIsNewChatOpen
}) => {
  // const [anchorEl, setAnchorEl] = useState(null);
  // const [openModalCallPermission, setOpenModalCallPermission] = useState(false)
  const dispatch = useDispatch();
  const { isInAutoDial } = useSelector((state) => state.agent);

  const { agentPermission, CurrentState, myInfo } = useSelector(
    (state) => state.auth
  );

  // const open = Boolean(anchorEl);

  // Icon background colors
  const bgColors = [
    "#005c55",
    "#13e1ce",
    "#24119b",
    "#2a51da",
    "#329702",
    "#35aeac",
    "#3e7e4f",
    "#4caf50",
    "#506c0b",
    "#552336",
    "#57cda3",
    "#5f72f0",
    "#5f8fac",
    "#623453",
    "#66702d",
    "#6e26c3",
    "#a15d8c",
    "#a1a770",
    "#a85142",
    "#ba68c8",
    "#baa0b2",
    "#bcd7f3",
    "#c0926f",
    "#d1fe87",
    "#d94953",
    "#dadd24",
    "#dfd7a8",
    "#edc1e2",
    "#f97427",
    "#ffe200",
  ];

  const handleCall = ({ number, phoneTypeID }) => {
    dispatch(
      setMakeCall({
        agentStatus: CurrentState,
        campaignID: campaignID,
        contactID: contactID,
        goToACW: campaignID ? true : false,
        phoneNo: number,
        phoneTypeID: phoneTypeID,
        /* ACWMode: acwMode && acwMode[0],
        ACWDuration: acwMode && acwMode[1], */
        ACWMode: acwMode,
        ACWDuration: acwDuration,
        isTelemarketing: isTelemarketing,
      })
    );

    setIsContactDetailsModalShown && setIsContactDetailsModalShown(false);
  };

  const renderAddEditButton = () => {
    const changePhoneNumberPermission = agentPermission.find(
      (permission) => permission.PermissionCode === "Contact.ChangePhoneNumber"
    );

    if (
      changePhoneNumberPermission &&
      changePhoneNumberPermission.PermissionAccess === "A" &&
      isAddEditButtonShown
    ) {
      return (
        <>
          <hr className="separator" />
          <div className="item add">
            <Tooltip arrow title="Add/Edit">
              <IconButton
                className="action-button"
                onClick={() => {
                  if (setIsAddEditContactDialogShown || myInfo.user.Level > 0) {
                    setIsAddEditContactDialogShown(true);
                  } else {
                    setIsAddChangeContactDialogShown(true);
                  }
                }}
              >
                <Icon icon="material-symbols:edit" width="26" />
              </IconButton>
            </Tooltip>

            <p>
              {!campaignID || myInfo.user.Level > 0 ? "Edit & " : ""} Add
              Contact Info
            </p>
          </div>
        </>
      );
    } else {
      return null;
    }
  };

  const renderItem = (typeID, index, phoneNo) => {
    let icon, type, action, isPhoneNumber;

    const callAction = (
      <>
        <Tooltip arrow title="Call">
          <IconButton
            className="action-button"
            disabled={isInAutoDial}
            onClick={() => handleCall({ number: phoneNo, phoneTypeID: typeID })}
          >
            <Phone />
          </IconButton>
        </Tooltip>
      </>
    );

    const messageAction = (
      <Tooltip arrow title="Send message">
        <IconButton className="action-button">
          <MailOutlinedIcon />
        </IconButton>
      </Tooltip>
    );

    const whatsappAction = (
      <>
        <Tooltip arrow title="WhatsApp">
          <IconButton
            className="action-button"
            onClick={() => {
              setSelectedNumber(phoneNo);
              setSelectedPhoneTypeID(typeID);
              setIsNewChatOpen(true);
            }}
          >
            <WhatsAppIcon />
          </IconButton>
        </Tooltip>

        {/* <Menu
          anchorEl={anchorEl}
          id="callButton"
          open={open}
          onClose={() => setAnchorEl(null)}
          onClick={() => setAnchorEl(null)}
          transformOrigin={{ horizontal: "center", vertical: "top" }}
          anchorOrigin={{ horizontal: "center", vertical: "bottom" }}
        >
          <MenuItem
            sx={{
              fontSize: "14px",
              padding: "6px 14px",
            }}
            onClick={() => {
              setSelectedNumber(phoneNo);
              setSelectedPhoneTypeID(typeID);
              setIsNewChatOpen(true);
            }}
          >
            Send Message
          </MenuItem>

          <MenuItem
            sx={{
              fontSize: "14px",
              padding: "6px 14px",
            }}
            onClick={() => setOpenModalCallPermission(true)}
          >
            Call Customer
          </MenuItem>
        </Menu> */}
      </>
    );

    switch (typeID) {
      case 1:
        icon = "mdi:briefcase";
        type = "Business";
        action = callAction;
        isPhoneNumber = true;
        break;

      case 9:
      case 10:
      case 17:
        icon = "material-symbols:smartphone";
        type = "Phone";
        action = callAction;
        isPhoneNumber = true;
        break;

      case 11:
        icon = "mdi:more-circle";
        type = "Other";
        action = callAction;
        isPhoneNumber = true;
        break;

      case 15:
      case 25:
        icon = "material-symbols:contact-emergency";
        type = "Emergency Contact";
        action = callAction;
        isPhoneNumber = true;
        break;

      case 32:
        icon = "material-symbols:alternate-email";
        type = "Email";
        action = messageAction;
        isPhoneNumber = false;
        break;

      case 33:
        icon = "mdi:twitter";
        type = "Twitter";
        action = messageAction;
        isPhoneNumber = false;
        break;

      case 34:
        icon = "mdi:facebook";
        type = "Facebook";
        action = messageAction;
        isPhoneNumber = false;
        break;

      case 35:
        icon = "ri:instagram-line";
        type = "Instagram";
        action = messageAction;
        isPhoneNumber = false;
        break;

      default:
        icon = "basil:other-1-outline";
        type = "Other";
        action = <div className="action-button" />;
        isPhoneNumber = false;
        break;
    }

    return (
      <div className="item" key={index}>
        <div className="icon" style={{ backgroundColor: bgColors[index] }}>
          <Icon
            icon={icon}
            style={{ backgroundColor: bgColors[index] }}
            width="26"
            height="26"
          />
        </div>

        <div className="data">
          <p className="type">{type}</p>

          <p className="value">
            {isPhoneNumber ? formatPhoneNumber(phoneNo) : phoneNo}
          </p>
        </div>

        <div className="action-buttons">
          {action}

          {(phoneNo.startsWith("62") || phoneNo.startsWith("08")) &&
            type !== "Other" &&
            !isTelemarketing && // Temp disabled for TSS
            whatsappAction}
        </div>
      </div>
    );
  };

  return (
    <div className="contact-information">
      <div className="list">
        {data?.map((contact, index) => {
          if (contact.PhoneNo === "0") return null; // Hide contacts with value '0'
          return renderItem(contact.PhoneTypeID, index, contact.PhoneNo);
        })}

        {renderAddEditButton()}
      </div>

      {/* {openModalCallPermission ? (
        <CallPermissionModal
          onClose={() => setOpenModalCallPermission(false)}
        />
      ) : (
        ""
      )} */}
    </div>
  );
};

export default ContactInformation;
